import { IconButton } from "@mui/material";
import styled from "@emotion/styled";

export const IconButtonForListWrapper = styled(IconButton)({
  fontSize: 10,
});
